import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=74a5baba&scoped=true&"
import script from "./ChatThread.vue?vue&type=script&lang=js&"
export * from "./ChatThread.vue?vue&type=script&lang=js&"
import style0 from "./ChatThread.vue?vue&type=style&index=0&id=74a5baba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5baba",
  null
  
)

export default component.exports